import * as React from 'react'
import { cn } from '../../lib/utils'

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(function Textarea(
  { className, ...props },
  ref
) {
  return (
    <textarea
      className={cn(
        'relative block w-full rounded-lg border-transparent bg-transparent shadow-none focus-visible:ring-0 focus-visible:ring-offset-0 data-disabled:opacity-50 data-disabled:cursor-not-allowed',
        className
      )}
      data-disabled={props.disabled ? 'true' : undefined}
      ref={ref}
      {...props}
    />
  )
})

export { Textarea }
